/**
 * Service Facilities feature auto-registration and exports
 *
 * This module automatically registers the service facilities feature when imported,
 * enabling management of service facility locations (CMS-1500 Box 32).
 */

import { autoRegisterFeature } from '@store/features/factory';

import { serviceFacilitiesFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(serviceFacilitiesFeature);

// Export shared components
export { ServiceFacilitiesTab } from './components/ServiceFacilitiesTab';
export { ServiceFacilityForm, type ServiceFacilityFormData } from './components/ServiceFacilityForm';
// Export store (all store-related exports)
export * from './store';
// Export types
export * from './types';
